module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "sidebar-nav"
  }, _vm._l((_vm.chapters), function(chapter) {
    return _c('li', {
      staticClass: "sidebar-nav-item"
    }, [(chapter.content) ? _c('router-link', {
      staticClass: "sidebar-chapter-title",
      attrs: {
        "exact": "",
        "to": ("/" + (chapter.id))
      }
    }, [_vm._v("\n        " + _vm._s(chapter.title) + "\n      ")]) : _c('span', {
      staticClass: "sidebar-chapter-title"
    }, [_vm._v("\n        " + _vm._s(chapter.title) + "\n      ")]), _vm._v(" "), (chapter.stories) ? _c('ul', {
      staticClass: "sidebar-stories"
    }, _vm._l((chapter.stories), function(story) {
      return _c('li', {
        staticClass: "sidebar-story"
      }, [_c('router-link', {
        staticClass: "sidebar-story-title",
        attrs: {
          "exact": "",
          "to": ("/" + (chapter.id) + "/" + (story.id))
        }
      }, [_vm._v("\n            " + _vm._s(story.title) + "\n          ")])], 1)
    })) : _vm._e()], 1)
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-29a52ae3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29a52ae3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 27
// module chunks = 0